module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signup":"Sign up"},"ja":{"signup":"Career Craftに相談する"}}')
  delete Component.options._Ctor
}
